module.exports = __webpack_public_path__ + "static/media/logo.3bf03f96.png";